import { render } from "./FooterToolbar.vue?vue&type=template&id=1296053a&scoped=true"
import script from "./FooterToolbar.vue?vue&type=script&lang=js"
export * from "./FooterToolbar.vue?vue&type=script&lang=js"

import "./FooterToolbar.vue?vue&type=style&index=0&id=1296053a&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1296053a"]])

export default __exports__
import QFooter from 'quasar/src/components/footer/QFooter.js';
import QToolbar from 'quasar/src/components/toolbar/QToolbar.js';
import QLinearProgress from 'quasar/src/components/linear-progress/QLinearProgress.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QFooter,QToolbar,QLinearProgress,QBtn});
